export const YoutubeThumbnail = ({ selectedImage }) => {
  return (
    <div className="ytImgContainer">
      <div className="ytImgWrapper">
        <div className="ytImgThumbBox">
          <img
            src={
              selectedImage ||
              require("@src/assets/images/vyrill/default.png").default
            }
            width="100%"
            height={363}
            className="ytImgThumbImg"
            alt="text"
          />
        </div>
      </div>
    </div>
  );
};

export const TikTokThumbnail = ({ selectedImage, customStyles, imgStyles }) => {
  return (
    <div className="text-center" style={customStyles}>
      <img
        src={
          selectedImage ||
          require("@src/assets/images/vyrill/default.png").default
        }
        width="100%"
        style={imgStyles}
        alt="text"
      />
    </div>
  );
};
